// Navegação movida para o Navbar — Sidebar desativada
export default function Sidebar() {
  return null;
}
